import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=3c883f61&scoped=true"
import script from "./MobileHeader.vue?vue&type=script&lang=js"
export * from "./MobileHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=3c883f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c883f61",
  null
  
)

export default component.exports